import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IconX, IconHome, IconRefresh } from '@tabler/icons-react';
import { Card } from '../components/ui/card';

const FailurePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const errorMessage = searchParams.get('error');

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background bg-noise flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="w-full max-w-2xl"
        data-testid="failure-page"
      >
        <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 sm:p-12 text-center">
          {/* Error Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
            className="inline-flex items-center justify-center w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-red-500/10 mb-6"
            data-testid="error-icon"
          >
            <IconX size={64} className="text-red-500" stroke={2} />
          </motion.div>

          {/* Title */}
          <h1 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl mb-4" data-testid="failure-title">
            Оплата не прошла
          </h1>

          {/* Description */}
          <p className="text-base sm:text-lg text-[color:hsl(var(--foreground))]/70 mb-6">
            К сожалению, платеж не был завершен.
          </p>

          {/* Error Message */}
          {errorMessage && (
            <div className="bg-red-500/10 rounded-[64px] p-4 mb-6">
              <p className="text-sm text-[color:hsl(var(--foreground))]/60">Причина</p>
              <p className="text-base text-red-500 mt-1" data-testid="error-message">
                {decodeURIComponent(errorMessage)}
              </p>
            </div>
          )}

          {/* Order Details */}
          {orderId && (
            <div className="bg-[color:hsl(var(--foreground))]/5 rounded-[64px] p-4 mb-8">
              <p className="text-sm text-[color:hsl(var(--foreground))]/60">Номер заказа</p>
              <p className="font-mono text-lg text-[color:hsl(var(--foreground))]/80 mt-1" data-testid="order-id">
                {orderId}
              </p>
            </div>
          )}

          {/* Info Message */}
          <p className="text-sm text-[color:hsl(var(--foreground))]/60 mb-8">
            Если у вас возникли вопросы, пожалуйста, свяжитесь с нами.<br />
            Мы всегда готовы помочь!
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center h-14 px-8 rounded-[128px] bg-[color:hsl(var(--brand-orange))] text-white text-base font-medium transition-[background-color,transform] duration-200 ease-out hover:bg-[color:hsl(var(--brand-orange-700))] hover:scale-105 shadow-lg"
              data-testid="try-again-button"
            >
              <IconRefresh size={20} className="mr-2" />
              Попробовать снова
            </button>
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center h-14 px-8 rounded-[128px] border-2 border-[color:hsl(var(--hairline))] text-[color:hsl(var(--foreground))] text-base font-medium transition-[border-color,transform] duration-200 ease-out hover:border-[color:hsl(var(--brand-orange))] hover:scale-105"
              data-testid="back-home-button"
            >
              <IconHome size={20} className="mr-2" />
              На главную
            </button>
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default FailurePage;
